import { render, staticRenderFns } from "./TopUser.vue?vue&type=template&id=406dd3cd&scoped=true"
import script from "./TopUser.vue?vue&type=script&lang=js"
export * from "./TopUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406dd3cd",
  null
  
)

export default component.exports